module.exports = __webpack_public_path__ + "f892362d57921ee257862559668128c3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/navigators/ic-anchor-bundle.svg
// module id = 1495
// module chunks = 3